module.exports = __webpack_public_path__ + "static/media/incident_switch.f8300111.png";